<div class="summary-wrapper d-flex flex-column justify-content-between">
    <div>
        <h3 class="h5 text-blue fw-bold fs-md-3 mb-2">{{ textHeader }}</h3>

        <div>
            <clamper #clamper class="fs-6 fs-md-18 mb-5" [maxLines]="summaryMaxLines" [text]="summaryText"></clamper>

            <div class="d-none d-print-block">
                <disease-at-a-glance-snippets [nestedHeading]="true"></disease-at-a-glance-snippets>
            </div>

            <div class="d-none d-print-block">
                <ng-container *ngTemplateOutlet="resources"></ng-container>
            </div>
        </div>
    </div>

    <div class="d-print-none">
        <ng-container *ngTemplateOutlet="resources"></ng-container>
    </div>
</div>

<ng-template #resources>
    <div *ngIf="moreInfoResources.length" class="mt-5">
        <h4 class="fs-5 fw-700 text-blue mb-4" [innerHTML]="infoTitle"></h4>
        <ul class="resource-list text-link fs-6 fs-md-18">
            <li *ngFor="let resource of moreInfoResources">
                <a target="_blank" [href]="resource.link" link>{{ resource.label }}</a
                >{{ ' ' }}<span [innerHTML]="resource.article.bodyText"></span>
            </li>
        </ul>
    </div>
</ng-template>
